<template>
  <div class="transaction_list">
    <v-col class="pt-5">
      <div>
        <v-row>
          <v-col cols="12" md="3" class="py-0 pr-md-0">
            <profile-menu></profile-menu>
          </v-col>
          <v-col cols="12" md="9" class="pl-md-5 py-0 mt-5 mt-md-0">
            <v-card id="panel-resumestore" elevation="1" outlined class="mt-5">
              <v-card-subtitle>
                <h4 class="pb-3 black--text">Ringkasan Transaksi Tempo</h4>
                <hr />
              </v-card-subtitle>
              <v-card-text>
                <div class="resume-list">
                  <v-row class="align-center">
                    <v-col cols="12" class="py-0">
                      <div class="resume-stats">
                        <v-card elevation="0" outlined class="stats-item">
                          <v-card-text>
                            <div class="stats-content">
                              <div class="stats-text">
                                <!-- <v-img
                                  width="30"
                                  position="center left"
                                  src="/assets/seller/status-pesanan-no-padding.png"
                                ></v-img> -->
                                <div class="text-left">
                                  <v-icon
                                  width="30" >mdi-clipboard-list</v-icon>
                                </div>
                                <router-link to="/transaction?type=tempo"
                                  class="d-block text-left font-weight-bold text-caption"
                                >
                                  Total Transaksi
                                </router-link>
                                <div
                                  class="d-block text-h5 font-weight-bold text-left black--text mt-1"
                                >
                                  {{ statisticPaymentData.total_transaction || 0 }}
                                </div>
                              </div>
                            </div>
                          </v-card-text>
                        </v-card>

                        <v-card elevation="0" outlined class="stats-item">
                          <v-card-text>
                            <div class="stats-content">
                              <div class="stats-text">
                                <!-- <v-img
                                  width="40"
                                  position="center left"
                                  src="/assets/seller/waktu-kirim.svg"
                                ></v-img> -->
                                <div class="text-left">
                                  <v-icon width="40" color="orange">mdi-clipboard-alert</v-icon>
                                </div>
                                <router-link to="/transaction?type=tempo&status=unpaid"
                                  class="d-block text-left font-weight-bold text-caption"
                                >
                                Transaksi Belum Lunas
                                </router-link>
                                <div
                                  class="d-block text-h5 font-weight-bold text-left black--text mt-1"
                                >
                                  {{ statisticPaymentData.total_hutang || 0 }}
                                </div>
                              </div>
                            </div>
                          </v-card-text>
                        </v-card>

                        <v-card elevation="0" outlined class="stats-item">
                          <v-card-text>
                            <div class="stats-content">
                              <div class="stats-text">
                                <!-- <v-img
                                  width="30"
                                  position="center left"
                                  src="/assets/seller/feedback-positif.svg"
                                ></v-img> -->
                                <div class="text-left">
                                  <v-icon color="green">mdi-clipboard-check</v-icon>
                                </div>
                                <router-link to="/transaction?type=tempo&status=paid"
                                  class="d-block text-left font-weight-bold text-caption"
                                >
                                  Transaksi Lunas
                                </router-link>
                                <div
                                  class="d-block text-h5 font-weight-bold text-left black--text mt-1"
                                >
                                {{ statisticPaymentData.total_dibayar || 0 }}
                                </div>
                              </div>
                            </div>
                          </v-card-text>
                        </v-card>


                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-col>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ProfileMenu from "@/components/layout/store/ProfileMenu";
import StatusTransaction from "@/components/StatusTransaction";
import ModalDelete from "@/components/ModalDelete";
import sectionFilter from "../../../components/sectionFilter.vue";
export default {
  components: {
    ProfileMenu,
    sectionFilter,
    StatusTransaction,
    ModalDelete,
  },
  data() {
    return {
      statusListTop: [
        {
          label: "Semua Status Pembayaran",
          value: "",
        },
        {
          label: "Pending",
          value: "pending",
        },
        {
          label: "Partial",
          value: "partial",
        },
        {
          label: "Paid",
          value: "paid",
        },
      ],
      statusList: [
        {
          label: "Semua Status Transaksi",
          value: "",
        },
        {
          value: "created",
          label: "Menunggu Pembayaran",
        },
        {
          value: "expired",
          label: "Transaksi Kedaluwarsa",
        },
        {
          value: "pending",
          label: "Menunggu Approval",
        },
        {
          value: "paid",
          label: "Menunggu Diproses Penjual",
        },
        {
          value: "processed",
          label: "Diproses Penjual",
        },
        {
          value: "on_delivery",
          label: "Proses Pengiriman",
        },
        {
          value: "completed",
          label: "Selesai",
        },
        {
          value: "rejected_admin",
          label: "Dibatalkan oleh Admin",
        },
        {
          value: "rejected_seller",
          label: "Dibatalkan oleh Penjual",
        },
        {
          value: "cancel",
          label: "Transaksi Dibatalkan",
        },
        {
          value: "pickup",
          label: "Pickup",
        },
        {
          value: "delivery",
          label: "Delivery",
        },
      ],
      statusFilter: {
        value: "",
        comparison: "=",
        type: "string",
        field: "trx_status",
      },
      statusFilterTop: {
        value: "",
        comparison: "=",
        type: "string",
        field: "payment_status",
      },
      page: 1,
      filter: {
        type: {
          label: "No. Invoice",
          value: "invoice",
        },
        search: "",
        filterId: null,
        sortId: null,
        dateRange: null,
      },
      tempoFilter: {
        value: "",
        comparison: "=",
        type: "string",
        field: "is_top",
      },
      invoiceFilter: {
        value: "",
        comparison: "like",
        type: "string",
        field: "trx_code",
      },
      limit: 5,
      homepage: process.env.VUE_APP_HOMEPAGE,
      params: [],
      sortBy: "trx_id",
      sortDir: "DESC",
      invoice_selected: "",
    };
  },
  computed: {
    ...mapState("transaction", [
      "loadTransaction",
      "transactionData",
      "transactionPagination",
      'statisticPaymentData'
    ]),
  },
  methods: {},
  created() {
    this.$store.dispatch('transaction/getStatisticTempoPayment')
  },
};
</script>

<style lang="scss" scoped>
  .resume-stats {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .stats-item {
      display: flex;
      flex: 1 0 25%;
      margin: 0;
      flex-grow: 0;
      .stats-content {
        display: block;
        text-align: center;
        .text-caption {
          display: block;
          text-align: left;
          width: 100%;
          margin-top: 10px;
          line-height: 1.2;
        }
      }
    }
  }

  @media (max-width: 959px) {
    .resume-stats {
      .stats-item {

        flex: 1 0 50%;
      }
    }
  }
</style>
